"use strict";
/**
 * Copyright © 2020 Johnson & Johnson
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

require("core-js/modules/es.array.reduce.js");

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var __spread = this && this.__spread || function () {
  for (var ar = [], i = 0; i < arguments.length; i++) {
    ar = ar.concat(__read(arguments[i]));
  }

  return ar;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var lodash_1 = require("lodash");

var removeLeaves = function removeLeaves(nodes) {
  if (!nodes) {
    return [];
  }

  var cleanedNodes = nodes.reduce(function (acc, node) {
    if (node.leaves) {
      // we don't need the node itself, as we exepct it to be a text node
      return __spread(acc, node.leaves.map(function (leave) {
        return __assign(__assign({}, leave), {
          object: 'text'
        });
      }));
    }

    var cleanedNode = node.nodes ? __assign(__assign({}, node), {
      nodes: removeLeaves(node.nodes)
    }) : node;
    return __spread(acc, [cleanedNode]);
  }, []);
  return cleanedNodes;
};

var migrateTextNode = function migrateTextNode(oldNode) {
  var marks = oldNode.marks !== undefined ? oldNode.marks.reduce(function (acc, mark) {
    var _a;

    return __assign(__assign({}, acc), (_a = {}, _a[mark.type] = !lodash_1.isEmpty(mark.data) ? mark.data : true, _a));
  }, {}) : {};
  return __assign({
    text: oldNode.text
  }, marks || {});
};

var migrateElementNode = function migrateElementNode(node) {
  if (node.nodes === undefined) return node; // eslint-disable-next-line @typescript-eslint/no-use-before-define

  var children = node.nodes.map(migrateNode);
  return {
    data: node.data ? node.data : {},
    type: node.type,
    children: children || []
  };
};

var migrateNode = function migrateNode(oldNode) {
  if (oldNode.object === 'text') {
    return migrateTextNode(oldNode);
  }

  return migrateElementNode(oldNode);
};

var withDataMigrator = function withDataMigrator(Component) {
  return function (_a) {
    var value = _a.value,
        rest = __rest(_a, ["value"]);

    var newValue = value;

    if (value.document !== undefined) {
      var nodes = removeLeaves(value.document.nodes);
      newValue = nodes.map(migrateNode) || [];
    }

    var props = __assign(__assign({}, rest), {
      value: newValue
    });

    return react_1.default.createElement(Component, __assign({}, props));
  };
};

exports.default = withDataMigrator;